// moz667: por culpa de vrdemo
var $ = jQuery;

// TODO: i18n
// TODO: textos

function update_seconds_left($time_left, seconds, on_end_callback) {
    var str_time_left = "";
    var remain_seconds = 0;
    var remain_minutes = 0;

    if (seconds < 60) {
        toggle_danger_on($time_left);
        remain_seconds = seconds;
    } else {
        remain_seconds = seconds % 60;
        remain_minutes = (seconds - remain_seconds) / 60;
    }

    str_time_left = (remain_minutes < 10 ? "0" : "") + remain_minutes;
    str_time_left += ":" + (remain_seconds < 10 ? "0" : "") + remain_seconds;

    $time_left.find(".time-value").text(str_time_left);

    if (seconds == 0) {
        on_end_callback();
    } else {
        setTimeout(function() {
            update_seconds_left($time_left, seconds - 1, on_end_callback);
        }, 1000);
    }
}

function toggle_danger_on($time_left) {
    if (!$time_left.hasClass("danger")) {
        $time_left.find(".time-icon").removeClass("fa-clock-o").addClass("fa-exclamation-circle");
        $time_left.addClass("danger");
    }
}

function toggle_danger_off($time_left) {
    if ($time_left.hasClass("danger")) {
        $time_left.find(".time-icon").removeClass("fa-exclamation-circle").addClass("fa-clock-o");
        $time_left.removeClass("danger");
    }
}

$(".one2one-video-chat").each(function () {
    var $this = $(this);
    var $window = $(window);
    var $button_wrap = $(".btn-group-toggle");

    var fix_height = function () {
        // 33 son los margin del hr + el alto del mismo 16 + 16 + 1
        // 16 para dejar un poco de margen mas
        $this.height($window.height() - $button_wrap.height() - 33 - 16);
    };

    if (typeof window.onorientationchange != 'undefined') {
        window.addEventListener("orientationchange", fix_height, false);
    } else {
        $window.resize( fix_height );
    }

    fix_height();

    // credentials
    var apiKey = $this.data("api-key");
    var sessionId = $this.data("session-id");
    var token = $this.data("token");
    var is_applicant = $this.data("is-applicant") == "true";
    var is_inprogress = $this.data("is-inprogress") == "true";
    var secs_to_end = parseInt($this.data("time-left-session-end"), 10);
    var secs_to_start = parseInt($this.data("time-left-session-start"), 10);
    var publisher = null;
    var is_finished = false;

    // connect to session
    var session = OT.initSession(apiKey, sessionId);

    /*
    // TODO: Esto es para hacer pruebas... borrar cuando ya no se permita acceder cuando falte mucho tiempo
    if (secs_to_start > (60 * 60)) {
        secs_to_start = 5;
    }

    update_seconds_left($this.find(".time-left"), secs_to_start, function () {
        toggle_danger_off($this.find(".time-left"));
    */
        update_seconds_left($this.find(".time-left"), secs_to_end, function () {
            is_finished = true;
            $(".waiting-message").hide();

            session.unpublish(publisher);

            alertDialog.show({
                title: "OneToOne Terminado",
                message: "Se ha terminado la sesión OneToOne. Esperamos que haya sido productiva.",
                onHide: function () {
                    document.location = N2M.HOME_URL;
                }
            });
        });
    // });

    // TODO: Lo que molaria es poder crear esto de forma dinamica permitiendo a los
    // asistentes a tener un minuto antes por si se quieren arreglar :P
    // por ahora asi que no da problemas
    session.on('streamCreated', function streamCreated(event) {
        var already_subscribed = false;
        /*
        FIXME: No funciona esto... era para intentar evitar que se conectaran al mismo one2one
        var subscribers = session.getSubscribersForStream(event.stream);
        console.log(subscribers);
        console.log(session.getPublisherForStream(event.stream));
        
        for (var i = 0; i < subscribers.length; i++) {
            var cur_subs = subscribers[i];
            if (cur_subs.stream.connection.connectionId == event.stream.connection.connectionId) {
                already_subscribed = true;
                break;
            }
        }
        */
        console.log("streamCreated");

        if (!already_subscribed) {
            var subscriberOptions = {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                name: $("#subscriber").data("subscriber-name"),
                style: { nameDisplayMode: "on" }
            };
            $(".waiting-message").hide();
            session.subscribe(
                event.stream, 'subscriber', subscriberOptions, handleError
            ).on("destroyed", show_waiting_message).on("disconnected", show_waiting_message);
        }
    });

    session.on('sessionDisconnected', function sessionDisconnected(event) {
        // TODO: i18n
        alertDialog.show({
            title: "Videollamada finalizada",
            message: "La comunicación ha finalizado correctamente.",
            onHide: function () {
                document.location = N2M.HOME_URL;
            }
        });
        // console.log('You were disconnected from the session.', event.reason);
    });

    // initialize the publisher
    var publisherOptions = {
        insertMode: 'append',
        width: '100%',
        height: '100%',
        name: $("#publisher").data("publisher-name"),
        style: { nameDisplayMode: "on" }
    };

    publisher = OT.initPublisher('publisher', publisherOptions, handleError);

    // Connect to the session
    session.connect(token, function callback(error) {
        if (error) {
            handleError(error);
        } else {
            // If the connection is successful, publish the publisher to the session
            session.publish(
                publisher, handleError
            ).on("destroyed", show_waiting_message).on("disconnected", show_waiting_message);
        }
    });

    function show_waiting_message(event) {
        event.preventDefault();
        if (!is_finished) {
            $(".waiting-message").show();
        }
    }

    var publish_video = true;
    
    $(".btn-video-switch").change(function () {
        if (publish_video) {
            publish_video = false;
            $(this).parent().find(".text").text("Video (Off)");
            $(this).parent().removeClass("active");
        } else {
            publish_video = true;
            $(this).parent().find(".text").text("Video (On)");
            $(this).parent().addClass("active");
        }

        publisher.publishVideo(publish_video);
    });

    var publish_audio = true;
    
    $(".btn-audio-switch").change(function () {
        
        if (publish_audio) {
            publish_audio = false;
            $(this).parent().find(".text").text("Audio (Off)");
            $(this).parent().removeClass("active");
        } else {
            publish_audio = true;
            $(this).parent().find(".text").text("Audio (On)");
            $(this).parent().addClass("active");
        }

        publisher.publishAudio(publish_audio);
    });

    $(".btn-disconect").click(function () {
        publisher.destroy();
        $("#videos").html("");
        // TODO: i18n
        alertDialog.show({
            title: "Videollamada finalizada",
            message: "La comunicación ha finalizado correctamente.",
            onHide: function () {
                document.location = N2M.HOME_URL;
            }
        });
    });
});

function handleError(error) {
    // Es muy raro pero siempre llama
    // console.log("XXXX ERROR XXXX");
    if (error) {
        // El error 1004 corresponde con un error de que el token ha caducado
        if (error.code == 1004) {
            alertDialog.show({
                title: "Sesión OneToOne terminada",
                message: "Ya ha caducado la sesión OneToOne.",
                onHide: function () {
                    document.location = N2M.HOME_URL;
                }
            });
        // Otros errores, los sacamos por pantalla
        } else if (error.message) {
            alertDialog.show({
                title: "Error (" + error.code + ")",
                message: error.message,
                onHide: function () {
                    document.location = N2M.HOME_URL;
                }
            });
        }
    }
}
